export default {
  'resultandfail.error.title': 'Submission Failed',
  'resultandfail.error.description':
    'Please check and modify the following information before resubmitting.',
  'resultandfail.error.hint-title': 'The content you submitted has the following error:',
  'resultandfail.error.hint-text1': 'Your account has been frozen',
  'resultandfail.error.hint-btn1': 'Thaw immediately',
  'resultandfail.error.hint-text2': 'Your account is not yet eligible to apply',
  'resultandfail.error.hint-btn2': 'Upgrade immediately',
  'resultandfail.error.btn-text': 'Return to modify',
};
